<template>
  <component
    :is="element.is"
    :model-value="modelValue"
    :rules="element.rules"
    v-bind="element.props"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template
      v-for="[name, html] in Object.entries(element.slots)"
      #[name]
      :key="name"
    >
      <div v-html="html"></div>
    </template>
  </component>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IStepInputElement } from "../model/flow.types"

  export default defineComponent({
    props: {
      element: {
        type: Object as PropType<IStepInputElement>,
        required: true,
      },
      modelValue: {
        // v-model has to be flexible and accept inputs of any type
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        type: [Object, String, Number, Boolean] as PropType<any>,
        default: undefined,
      },
    },
    emits: ["update:modelValue"],
  })
</script>
